import React, { useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import { useParams } from 'react-router-dom'
import {
  PixelButton,
  DcDropDown,
  PixelFactoryContext,
  PixelFlexBox,
  DcInput,
} from 'pixel-base'

import { updateCourierCredentials } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

const EditCourierCredential = (props) => {
  const params = useParams()
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const { courierId, courierTypes, courierCompanies, courier, handleClose } =
    props
  const id = courierId ?? params?.id ?? courier?.courier_id
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const [activeCompany, setActiveCompany] = React.useState<any>(null)
  const [fields, setFields] = React.useState<any[]>([])
  const [data, setData] = React.useState<Record<string, any>>({
    access_type: 1,
    company_id: '',
    password: '',
    courier_username: '',
    courier_cos_centre: '',
    api_key: '',
  })
  const fieldName = ['Account Number', 'Origin City']
  const handleSubmit = (e) => {
    e.preventDefault()
    handleUpdateCourierCredential()
  }
  const getAllCourierCompanies = () => {
    const companies = courierCompanies
      ?.map((c) => {
        c['slug'] = c.name.replace(/\s+/g, '-').toLowerCase()
        return c
      })
      .filter((c) => {
        return !!c.schema
      })

    if (companies?.length && courier) {
      getCourierDetails(companies)
    }
  }
  const getTypeName = (id) => {
    const type = courierTypes.find((t) => {
      return t.courier_type_id == id
    })
    return type ? type.courier_type : 'api'
  }

  const handleUpdateCourierCredential = () => {
    if (!activeCompany?.id || !id) return
    showPageLoader()
    const postData: any = {
      ...data,
      company_id: activeCompany.id,
      courier_username: data.username ?? data.courier_username,
      courier_cos_centre:
        data.cost_center ?? data.courier_cos_centre ?? data.cos_center,
    }

    updateCourierCredentials(id, postData).subscribe((res: any) => {
      hidePageLoader()
      if (res.response && courier.courier_id) {
        showSuccess('Successfully Updated')
        handleClose(res.response)
      } else {
        if (res.response && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response)
        }
      }
    })
  }
  const getCourierDetails = (companies) => {
    const company = findActiveCompany(companies)
    setActiveCompany(company)
    if (company?.schema?.types?.['api']) {
      setFields(company.schema.types['api'])
    } else {
      setFields([])
    }
  }
  const findActiveCompany = (companies) => {
    const company_id = courier.company_id
      ? courier.company_id
      : courier?.courier_company.id
    return companies?.find((company: any) => company.id == company_id)
  }

  useEffect(() => {
    if (!courier) return
    const mappedData = {
      ...courier,
      access_type: courier.courier_type?.courier_type_id ?? courier.access_type,
      username: courier.courier_username ?? courier.username,
      password: courier.courier_password ?? courier.password,
      origin_city: courier.courier_origin_city ?? courier.origin_city,
      cost_center:
        courier.courier_cos_centre ?? courier.cos_center ?? courier.cost_center,
    }
    setData(mappedData)
  }, [courier])

  useEffect(() => {
    if (courierCompanies?.length && courier) {
      getAllCourierCompanies()
    }
  }, [courierCompanies, courier])
  return (
    <>
      {/* this is some thing */}
      {/* {activeCompany && ( */}
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
        onSubmit={handleSubmit}
      >
        <PixelFlexBox
          width="100%"
          gap="10px"
          style={{ flexGrow: '1', flexDirection: isMobile && 'column' }}
          isMobile={isMobile}
        >
          <DcDropDown
            isShowLabel={true}
            customLabel={'Tracking/Access Type'}
            label={'Tracking/Access Type'}
            error={
              error.field === 'access_type' && error.error !== ''
                ? error.error
                : null
            }
            required
            placeholder={'Select Tracking/Access Type'}
            options={courierTypes.map((p: any) => {
              return {
                label: p.courier_type,
                value: p.courier_type_id,
                disabled:
                  (activeCompany?.schema?.disallowed_types?.indexOf(
                    p.courier_type,
                  ) ?? -1) !== -1,
              }
            })}
            value={data.access_type || ''}
            onChange={(e) => {
              const typeName = getTypeName(e.target.value)
              const typeFields = activeCompany?.schema?.types?.[typeName] ?? []
              setFields(typeFields)
              setData({ ...data, access_type: e.target.value })
            }}
          />
        </PixelFlexBox>
        {fields
          ?.filter((field) => {
            return fieldName.indexOf(field.field_name) === -1
          })
          ?.map((field, i) => {
            return (
              <PixelFlexBox
                key={i}
                width="100%"
                gap="10px"
                style={{ flexGrow: '1', flexDirection: isMobile && 'column' }}
                isMobile={isMobile}
              >
                <DcInput
                  isShowLabel={true}
                  customLabel={field.field_name}
                  label={field.field_name}
                  error={
                    error.field === field.field && error.error !== ''
                      ? error.error
                      : null
                  }
                  type={field.type}
                  name={field.field}
                  required
                  placeholder={field.field_name}
                  value={data[field.field] || ''}
                  onChange={(e) =>
                    setData({ ...data, [field.field]: e.target.value })
                  }
                />
              </PixelFlexBox>
            )
          })}
        <PixelFlexBox
          width="100%"
          gap="10px"
          style={{ flexGrow: '1', flexDirection: isMobile && 'column' }}
          justifyContent="flex-end"
          isMobile={isMobile}
        >
          <PixelButton type={'submit'}>Save</PixelButton>
        </PixelFlexBox>
      </form>
      {/* )} */}
    </>
  )
}

export default EditCourierCredential
